import TimeRangePicker from 'time-range-picker'
import AuthButton from '../components/AuthButton'
import Pagination from '../components/Pagination'
import Selector from '../components/Selector'
import FormDialog from '../components/FormDialog'
import FormItemTip from '../components/FormItemTip'
import Tag from '../components/Tag'

function requireAll (requireContext) {
  return requireContext.keys().map(requireContext)
}

const install = (Vue, opts = {}) => {
  if (install.installed) {
    return
  }

  const components = [
    //...requireAll(require.context('../handy-components', true, /^\.\/.*\.vue$/)),
    TimeRangePicker,
    AuthButton,
    Pagination,
    Selector,
    FormDialog,
    FormItemTip,
    Tag
  ]

  for (let i = 0; i < components.length; i++) {
    // 兼容 import export 和 require module.export 两种规范
    if (components[i].name === undefined && components[i].default) {
      components[i] = components[i].default
    }
    if (components[i].install) {
      Vue.use(components[i], opts[components[i].name])
    } else if (components[i].name) {
      Vue.component(components[i].name, components[i])
    }
  }

  install.installed = true
}

export default {
  install
}
